export default {
  propertyAddress: {
    address: null,
    unit: null,
    city: null,
    state: null,
    zipCode: null,
  },
  ownershipPercentage: null,
  propertyType: null,
  purchaseDate: null,
  purchasePrice: null,
  saleDate: null,
  salePrice: null,
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/real_estate/resources/realEstateOperation.js